import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";

import CommentList from "@/modules/news/admin/components/CommentList";

export const Route = createFileRoute("/admin/_panel/_news/news/comments/")({
  component: Component,
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Manage Comments", { ns: "news.admin" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function Component() {
  const { t } = useTranslation("news.admin");
  return (
    <Container
      title={t("Manage Comments")}
      description={t("Manage, Create, Edit Comments")}
    >
      <CommentList />
    </Container>
  );
}
